import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var Spacer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin-bottom: ", "px;\n\n  @media (min-width: ", "px) {\n    margin-bottom: ", "px;\n  }\n"], ["\n  width: 100%;\n  margin-bottom: ", "px;\n\n  @media (min-width: ", "px) {\n    margin-bottom: ", "px;\n  }\n"])), function (props) {
  return props.theme.spacings ? props.theme.spacings[props.xsSpacing] : 0;
}, function (props) {
  var _a, _b;

  return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.xs;
}, function (props) {
  return props.theme.spacings ? props.theme.spacings[props.lgSpacing] : 0;
});
var templateObject_1;
export { Spacer };